import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";

const API = process.env.REACT_APP_API_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({
    loading: false,
    msg: null,
    ok: false,
  });

  async function onSubmit(e) {
    e.preventDefault();
    setStatus({ loading: true, msg: null, ok: false });

    try {
      const res = await fetch(`${API}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      // Réponse volontairement neutre côté API
      if (!res.ok && res.status !== 200) {
        throw new Error("Erreur réseau");
      }

      setStatus({
        loading: false,
        ok: true,
        msg:
          "Si un compte existe pour cette adresse, un email vient d’être envoyé avec la procédure de réinitialisation.",
      });
      setEmail("");
    } catch (err) {
      console.error(err);
      setStatus({
        loading: false,
        ok: false,
        msg: "Une erreur est survenue. Réessayez dans quelques minutes.",
      });
    }
  }

  return (
    <div className="min-h-screen bg-slate-50 relative overflow-hidden flex items-center justify-center px-4 py-12">
      <div
        className="pointer-events-none absolute inset-0 opacity-70"
        style={{
          background:
            "radial-gradient(circle at 15% 0%, rgba(99,102,241,0.18) 0, transparent 55%), radial-gradient(circle at 85% 10%, rgba(249,115,22,0.12) 0, transparent 55%)",
        }}
      />

      <div
        className="pointer-events-none absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, rgba(15,23,42,0.12) 1px, transparent 1px), linear-gradient(to bottom, rgba(15,23,42,0.12) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
          maskImage:
            "radial-gradient(circle at 50% 10%, black 0%, transparent 70%)",
          WebkitMaskImage:
            "radial-gradient(circle at 50% 10%, black 0%, transparent 70%)",
        }}
      />

      <div className="relative max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-6 sm:p-8">
        <h1 className="text-xl font-semibold text-slate-900 text-center mb-1">
          Mot de passe oublié
        </h1>
        <p className="text-xs text-slate-500 text-center mb-6 leading-relaxed">
          Indiquez votre email professionnel.  
          Si un compte existe, vous recevrez un lien sécurisé pour choisir un
          nouveau mot de passe (valable 60&nbsp;minutes).
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">
              Email professionnel
            </label>
            <div className="relative">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="prenom.nom@entreprise.com"
                className="w-full rounded-xl border border-slate-300 bg-slate-50/60 px-3 py-2.5 pl-9 text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              />
              <Mail className="absolute left-3 top-[14px] h-4 w-4 text-slate-400" />
            </div>
          </div>

          {status.msg && (
            <div
              className={`rounded-xl px-3 py-2 text-xs border ${
                status.ok
                  ? "bg-emerald-50 border-emerald-200 text-emerald-700"
                  : "bg-red-50 border-red-200 text-red-700"
              }`}
            >
              {status.msg}
            </div>
          )}

          <button
            type="submit"
            disabled={status.loading}
            className="
              w-full mt-2 inline-flex items-center justify-center gap-2
              rounded-xl bg-indigo-600 px-4 py-3
              text-sm font-semibold text-white
              shadow-sm
              hover:bg-indigo-500
              disabled:opacity-60
              focus-visible:outline-none
              focus-visible:ring-2 focus-visible:ring-indigo-500
              focus-visible:ring-offset-2 focus-visible:ring-offset-slate-50
              transition
            "
          >
            {status.loading ? "Envoi en cours…" : "Envoyer le lien"}
          </button>
        </form>

        <p className="mt-5 text-xs text-slate-600 text-center">
          <Link
            to="/login"
            className="text-indigo-600 hover:text-indigo-500 font-medium"
          >
            ← Revenir à la connexion
          </Link>
        </p>

        <div className="mt-6 flex items-center justify-center gap-2 text-[11px] text-slate-500">
          <ShieldCheck className="h-3.5 w-3.5 text-slate-400" />
          Procédure sécurisée — aucune information révélée
        </div>
      </div>
    </div>
  );
}
